import React from 'react'
// import mainbanner from "../images/banner _mak.jpg";
// import Adventure_cum_NatureStudyCampatDarjeelingKalimpong from "../images/summer camp er BANNER.jpeg";
// import mainbannerim9 from "../images/im9.jpg";
import mak_update from "../images/mak_update.jpg"
import photo from "../images/21.jpg"
function Slider() {
  return (
    <div>
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>

  

  </div>
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={mak_update} className="d-block w-100" alt="MAK"/>
    </div>
    <div className="carousel-item">
      <img src={photo} className="d-block w-100" alt="ountaineers’ Association of Krishnanagar"/>
    </div>
     
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Slider